import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from 'src/components/common/designSystem/Button';
import { UserType } from 'src/types/user.types';

interface FamilyCodePanelProps {
  onClose: () => void;
  selectedUserType?: UserType | null;
}

const FamilyCodePanel = ({
  selectedUserType,
  onClose,
}: FamilyCodePanelProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isParent = selectedUserType === UserType.parent;
  const [searchParams] = useSearchParams();

  const handleHaveFamilyCode = () => {
    onClose();
    // Pass through any existing query parameters
    navigate(`/family-code?${searchParams.toString()}`);
  };

  return (
    <div
      className="flex flex-col items-center p-6 gap-6"
      data-testid="family-code-panel-content"
    >
      <div className="font-bold text-xl text-center text-balance">
        {isParent
          ? t('family.code.panel.parent.title')
          : t('family.code.panel.child.title')}
      </div>

      <div className="flex flex-col w-full gap-2">
        <Button
          type="primary"
          onClick={handleHaveFamilyCode}
          className="font-bold"
          data-testid="have-family-code-button"
        >
          {t('global.yes')}
        </Button>
        <Button
          onClick={onClose}
          className="font-bold"
          data-testid="btn-no-family-code"
        >
          {t('global.no')}
        </Button>
      </div>
    </div>
  );
};

export default FamilyCodePanel;
